import {addToCart, updateItem} from 'cart';
import 'utils';
import 'component/modal-trigger';

window.theme.cart = window.theme.cart || {};
window.theme.cart.addToCart = addToCart;
window.theme.cart.updateItem = updateItem;

import('events').catch((error) => {
  console.warn(`tracking-events unavailable: ${error.message}`);
});

// Opens the cart drawer on load when redirected from /cart.
const openCartDrawerFromHash = () => {
  if (window.location.hash !== '#open-cart') return;

  customElements
    .whenDefined('lab-modal')
    .then(() => {
      window.theme?.modals?.cart?.open?.();
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    })
    .catch((error) => {
      console.error(error.message);
    });
};

openCartDrawerFromHash();

/** ********************************************************************************** */
/** ********************************DO NOT EDIT BELOW********************************* */
/** ********************************************************************************** */

const logShoplabBranding = () => {
  console.log(
    '%c shoplab',
    'background:#000639;padding:20px;color:#fff;font:bold 1.9em/1 Helvetica Neue,Helvetica,Arial,sans-serif;width:400px'
  );
  console.log(
    '%c Shopify Experts \n www.shoplab.cc',
    'background:#fff;color:#000639;font:bold 1.1em/1.2 Helvetica Neue,Helvetica,Arial,sans-serif;width:400px'
  );
};

const labDOMready = (fn) => {
  if (document.readyState !== 'loading') fn();
  else document.addEventListener('DOMContentLoaded', fn);
};

labDOMready(() => {
  document.dispatchEvent(new CustomEvent('page:loaded'));
  logShoplabBranding();
});
